// extracted by mini-css-extract-plugin
export default {"container":"Counters_container__+K1a2","header":"Counters_header__tHRJV","backButton":"Counters_backButton__pancE"};